import { IOrder } from '../../../../app/entities/Order'
import { ITireRackOrder } from '../../../../app/entities/TireRackOrder'
import { CELL_PLACEMENT_STATUS } from '../constants/cell-tire-rack-order'

function getCellPlacementStatusOfTireRackOrder(
  tireRackOrder: ITireRackOrder,
): CELL_PLACEMENT_STATUS {
  if (!tireRackOrder.cellPlacement) {
    return CELL_PLACEMENT_STATUS.ZERO_PLACED
  } else {
    return tireRackOrder.cellPlacement.status
  }
}

function getCellPlacementStatusOfOrder(
  order: IOrder,
): CELL_PLACEMENT_STATUS | null {
  const isNoTROrders =
    !order.tireRackOrders || order.tireRackOrders.length === 0
  if (isNoTROrders) {
    return null
  }
  const areAllTROrdersAllPlaced = order.tireRackOrders.every(
    (tireRackOrder) =>
      getCellPlacementStatusOfTireRackOrder(tireRackOrder) ===
      CELL_PLACEMENT_STATUS.ALL_PLACED,
  )
  if (areAllTROrdersAllPlaced) {
    return CELL_PLACEMENT_STATUS.ALL_PLACED
  }
  const areAllTROrdersZeroPlaced = order.tireRackOrders.every(
    (tireRackOrder) =>
      getCellPlacementStatusOfTireRackOrder(tireRackOrder) ===
      CELL_PLACEMENT_STATUS.ZERO_PLACED,
  )
  if (areAllTROrdersZeroPlaced) {
    return CELL_PLACEMENT_STATUS.ZERO_PLACED
  }

  const isSomeTROrderUnderloaded = order.tireRackOrders.some((tireRackOrder) =>
    [
      CELL_PLACEMENT_STATUS.UNDERLOADED,
      CELL_PLACEMENT_STATUS.ALL_PLACED,
    ].includes(getCellPlacementStatusOfTireRackOrder(tireRackOrder)),
  )
  const isSomeTROrderOverloaded = order.tireRackOrders.some(
    (tireRackOrder) =>
      getCellPlacementStatusOfTireRackOrder(tireRackOrder) ===
      CELL_PLACEMENT_STATUS.OVERLOADED,
  )
  if (isSomeTROrderOverloaded && !isSomeTROrderUnderloaded) {
    return CELL_PLACEMENT_STATUS.UNDERLOADED
  } else {
    return CELL_PLACEMENT_STATUS.UNDERLOADED
  }
}

export { getCellPlacementStatusOfTireRackOrder, getCellPlacementStatusOfOrder }
